import * as yup from 'yup';
import { ValidationMessages } from 'shared/models/Validation';

export const costCenterValidationSchema = yup.object().shape({
    number: yup.number()
        .min(1, 'Number should be more than 0')
        .required(ValidationMessages.REQUIRED),
    description: yup.string().trim().required(ValidationMessages.REQUIRED),
});
